import { cx } from '@linaria/core';
import { Link } from '@provider/navigation';
import { DownloadIcon, ExternalLinkIcon } from '@ui/kit';
import { Chevron } from '@utils/react';
import { themeIconCls, secondaryThemeChevronCls, linkCls, modifiers } from './link.styles.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function TextLink(props) {
  const isDownloadLink = props.download || typeof props.href === "string" && props.href.startsWith(process.env["PM2_MEDIA_DOMAIN"] ?? "--");
  const linkIcon = isDownloadLink ? /*#__PURE__*/jsx(DownloadIcon, {
    className: themeIconCls
  }) : props.target === "_blank" ? /*#__PURE__*/jsx(ExternalLinkIcon, {
    className: themeIconCls
  }) : undefined;
  return /*#__PURE__*/jsxs(Link, {
    ...props,
    ref: props.ref,
    "data-theme": props.theme,
    className: cx("gInternalLink", linkCls, props.className, linkIcon && modifiers.withIcon.className),
    children: [props.theme === "primary" && linkIcon, props.theme === "secondary" && /*#__PURE__*/jsx("span", {
      className: secondaryThemeChevronCls,
      children: /*#__PURE__*/jsx(Chevron, {
        size: 6,
        lineWidth: 1.5
      })
    }), props.children, props.theme === "secondary" && linkIcon]
  });
}

export { TextLink };
//# sourceMappingURL=link.js.map
